import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontPlayfairDisplay, fontRobotoCondensed, theme } from "shared/lib/styles";

import type { ContentHeadlineVariant } from "scmp-app/components/content/content-headline";

export const Headline = styled.span``;

export const SponsorHeadline = styled.span`
  font-family: ${fontRobotoCondensed};
`;

type ContainerProps = {
  $variant?: ContentHeadlineVariant;
};

const Container = styled.h1<ContainerProps>`
  ${props => {
    if (props.$variant === "generic") {
      return css`
        display: flex;
        flex-direction: column;
        row-gap: 2px;

        ${theme.breakpoints.up("tablet")} {
          row-gap: 0;
        }
      `;
    }
  }}

  ${props => {
    if (props.$variant === "magazines-style") {
      return css`
        color: #222222;
        font-weight: 400;
        font-size: 28px;
        font-family: ${fontPlayfairDisplay};
        line-height: normal;
        letter-spacing: -0.28px;

        ${theme.breakpoints.up("tablet")} {
          font-size: 32px;
          line-height: 40px;
          letter-spacing: -0.32px;
        }

        ${theme.breakpoints.up("desktop")} {
          font-size: 40px;
          line-height: 48px;
          letter-spacing: -0.4px;
        }
      `;
    }
  }}
`;

export const H1Container = Container.withComponent("h1");
export const H2Container = Container.withComponent("h2");
export const H3Container = Container.withComponent("h3");
export const H4Container = Container.withComponent("h4");
export const H5Container = Container.withComponent("h5");
